import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { submitFeedback } from '../utils/newbackendcall';
import { useUser } from '../../../../context/UserContext';
import '../styles/FeedbackModal.css';

const FeedbackModal = ({ isOpen, onClose, article }) => {
    const { user } = useUser();
    const [userName, setUserName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [relevance, setRelevance] = useState('');
    const [feedback, setFeedback] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (user) {
            const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ');
            setUserName(fullName || '');
            setCompanyName(user.company_name_for_growth_iq || '');
        }
    }, [user]);

    if (!isOpen) return null;

    const getImportanceValue = (rel) => {
        switch (rel) {
            case 'highly-relevant': return 1;
            case 'somewhat-relevant': return 2;
            case 'not-relevant': return 3;
            default: return 2;
        }
    };

    const handleSubmit = async () => {
        if (userName.trim() === '') {
            alert('Please enter your name');
            return;
        }
        if (companyName.trim() === '') {
            alert('Please enter your company name');
            return;
        }
        if (!relevance) {
            alert('Please select a relevance option');
            return;
        }
        setIsSubmitting(true);
        try {
            // Wrap single article in array for consistent handling
            const articles = Array.isArray(article) ? article : [article];
            const newsItems = articles.map(a => ({
                news_id: a.id,
                title: a.title,
                url: a.url,
            }));
            await submitFeedback({
                username: userName,
                companyName,
                comment: feedback || `Rated as: ${relevance}`,
                importance: getImportanceValue(relevance),
                newsItems
            });
            alert('Feedback submitted successfully!');
            setUserName('');
            setCompanyName('');
            setRelevance('');
            setFeedback('');
            onClose();
        } catch (error) {
            console.error('Failed to submit feedback:', error);
            alert('Failed to submit feedback. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="feedback-modal-overlay-news" onClick={onClose}>
            <div className="feedback-modal-content-news" onClick={(e) => e.stopPropagation()}>
                <div className="feedback-modal-header-news">
                    <h2 className="feedback-modal-title-news">Submit Feedback</h2>
                    <button className="feedback-modal-close-news" onClick={onClose}>
                        <X size={24} />
                    </button>
                </div>

                <div className="feedback-modal-body-news">
                    <div className="feedback-form-group-news">
                        <div className="sender-info-news">
                            <span className="sender-label-news">From:</span>
                            <span className="sender-details-news">{userName} ({companyName})</span>
                        </div>
                    </div>

                    <div className="feedback-form-group-news">
                        <label className="feedback-question-news">Was this news relevant to your needs?</label>
                        <div className="radio-group-news">
                            <label className="radio-label-news">
                                <input
                                    type="radio"
                                    name="relevance"
                                    value="highly-relevant"
                                    checked={relevance === 'highly-relevant'}
                                    onChange={(e) => setRelevance(e.target.value)}
                                    className="radio-input-news"
                                />
                                <span>Highly Relevant</span>
                            </label>
                            <label className="radio-label-news">
                                <input
                                    type="radio"
                                    name="relevance"
                                    value="somewhat-relevant"
                                    checked={relevance === 'somewhat-relevant'}
                                    onChange={(e) => setRelevance(e.target.value)}
                                    className="radio-input-news"
                                />
                                <span>Somewhat Relevant</span>
                            </label>
                            <label className="radio-label-news">
                                <input
                                    type="radio"
                                    name="relevance"
                                    value="not-relevant"
                                    checked={relevance === 'not-relevant'}
                                    onChange={(e) => setRelevance(e.target.value)}
                                    className="radio-input-news"
                                />
                                <span>Not Relevant</span>
                            </label>
                        </div>
                    </div>

                    <div className="feedback-form-group-news">
                        <label className="feedback-label-news">
                            Please share any additional information or feedback for the content :
                        </label>
                        <textarea
                            placeholder=""
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                            className="feedback-textarea-news"
                            rows={4}
                        />
                    </div>
                </div>

                <div className="feedback-modal-footer-news">
                    <button
                        className="submit-feedback-button-news"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeedbackModal;
